import $ from 'cash-dom';

$(() => {
  const $elBtnRecover = $('.js-btnRecover');
  const $elBtnRecoverBack = $('.js-btnRecoverBack');
  const $elFormLoginMain = $('.js-loginMain');
  const $elFormLoginRecover = $('.js-loginRecover');

  function showFormRecover() {
    $elFormLoginMain.addClass('isHidden');
    $elFormLoginRecover.removeClass('isHidden');
  }

  // Happens after recover submit
  if (window.location.hash === '#recover') {
    showFormRecover();
  }

  $elBtnRecover.on('click', () => {
    showFormRecover();
  });

  $elBtnRecoverBack.on('click', () => {
    $elFormLoginMain.removeClass('isHidden');
    $elFormLoginRecover.addClass('isHidden');
  });
});
